/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createWorkPackageType } from '../fn/work-package-types/create-work-package-type';
import { CreateWorkPackageType$Params } from '../fn/work-package-types/create-work-package-type';
import { deleteWorkPackageType } from '../fn/work-package-types/delete-work-package-type';
import { DeleteWorkPackageType$Params } from '../fn/work-package-types/delete-work-package-type';
import { getWorkPackageType } from '../fn/work-package-types/get-work-package-type';
import { GetWorkPackageType$Params } from '../fn/work-package-types/get-work-package-type';
import { listWorkPackageTypes } from '../fn/work-package-types/list-work-package-types';
import { ListWorkPackageTypes$Params } from '../fn/work-package-types/list-work-package-types';
import { updateWorkPackageType } from '../fn/work-package-types/update-work-package-type';
import { UpdateWorkPackageType$Params } from '../fn/work-package-types/update-work-package-type';
import { WorkPackageTypeDto } from '../models/work-package-type-dto';
import { WorkPackageTypeDtoPage } from '../models/work-package-type-dto-page';

@Injectable({ providedIn: 'root' })
export class WorkPackageTypesApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listWorkPackageTypes()` */
  static readonly ListWorkPackageTypesPath = '/v0/workPackageTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listWorkPackageTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  listWorkPackageTypes$Response(params?: ListWorkPackageTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageTypeDtoPage>> {
    return listWorkPackageTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listWorkPackageTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listWorkPackageTypes(params?: ListWorkPackageTypes$Params, context?: HttpContext): Observable<WorkPackageTypeDtoPage> {
    return this.listWorkPackageTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPackageTypeDtoPage>): WorkPackageTypeDtoPage => r.body)
    );
  }

  /** Path part for operation `getWorkPackageType()` */
  static readonly GetWorkPackageTypePath = '/v0/workPackageTypes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWorkPackageType()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkPackageType$Response(params: GetWorkPackageType$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageTypeDto>> {
    return getWorkPackageType(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWorkPackageType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkPackageType(params: GetWorkPackageType$Params, context?: HttpContext): Observable<WorkPackageTypeDto> {
    return this.getWorkPackageType$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPackageTypeDto>): WorkPackageTypeDto => r.body)
    );
  }

  /** Path part for operation `updateWorkPackageType()` */
  static readonly UpdateWorkPackageTypePath = '/v0/workPackageTypes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateWorkPackageType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateWorkPackageType$Response(params: UpdateWorkPackageType$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateWorkPackageType(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateWorkPackageType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateWorkPackageType(params: UpdateWorkPackageType$Params, context?: HttpContext): Observable<void> {
    return this.updateWorkPackageType$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createWorkPackageType()` */
  static readonly CreateWorkPackageTypePath = '/v0/workPackageTypes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createWorkPackageType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWorkPackageType$Response(params: CreateWorkPackageType$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageTypeDto>> {
    return createWorkPackageType(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createWorkPackageType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWorkPackageType(params: CreateWorkPackageType$Params, context?: HttpContext): Observable<WorkPackageTypeDto> {
    return this.createWorkPackageType$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPackageTypeDto>): WorkPackageTypeDto => r.body)
    );
  }

  /** Path part for operation `deleteWorkPackageType()` */
  static readonly DeleteWorkPackageTypePath = '/v0/workPackageTypes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteWorkPackageType()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteWorkPackageType$Response(params: DeleteWorkPackageType$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteWorkPackageType(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteWorkPackageType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteWorkPackageType(params: DeleteWorkPackageType$Params, context?: HttpContext): Observable<void> {
    return this.deleteWorkPackageType$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
